import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useGAPageViews() {
  const location = useLocation();

  useEffect(() => {
    // @ts-ignore
    if (typeof window.gtag !== 'function') return;

    const page_path = location.pathname + location.search + location.hash;
    const page_title = document.title;
    const page_location = window.location.href;

    // @ts-ignore
    window.gtag('event', 'page_view', {
      page_path,
      page_title,
      page_location,
    });
  }, [location.pathname, location.search, location.hash]);
}
